export const menuList = [
  { label: "网站首页", path: "/" },
  { label: "走进新恒基", path: "/about" },
  { label: "新闻中心", path: "/news" },
  { label: "产品与应用", path: "/product" },
  { label: "生产设施", path: "/shengchan" },
  { label: "服务与支持", path: "/support" },
  { label: "人才招聘", path: "/jobs" },
]